/* -------------------------------------------
    Product Page
------------------------------------------- */

// Quick Order List Toggle with persistent JS state

const quickOrderState = new Map(); // key: sectionId, value: 'collapsed' | 'expanded'

window.toggleQuickOrderList = function(el) {
  

  const section = el.closest('section');
  if (!section) return;

  const sectionId = section.dataset.sectionId || section.id; // stable identifier
  const target = section.querySelector('.quick-order-list');
  if (!target) return;

  // Initialize target if first time
  if (!quickOrderState.has(sectionId)) {
    
    quickOrderState.set(sectionId, "collapsed");
  }

  // Always enforce the required inline styles
  target.style.overflow = "hidden";
  target.style.transition = "max-height 0.4s ease";

  let state = quickOrderState.get(sectionId);
  

  const arrow = el.querySelector('.QOL_Arrow');

  if (state === "collapsed") {
    
    target.style.maxHeight = target.scrollHeight + "px";
    quickOrderState.set(sectionId, "expanded");
    if (arrow) {
      arrow.classList.remove('fa-chevron-down');
      arrow.classList.add('fa-chevron-up');
    }
  } else {
    
    target.style.maxHeight = "0px";
    quickOrderState.set(sectionId, "collapsed");
    if (arrow) {
      arrow.classList.remove('fa-chevron-up');
      arrow.classList.add('fa-chevron-down');
    }
  }  
};

// -------

// Auto-collapse on page load or after UI refresh

function initQuickOrderSections() {
  document.querySelectorAll('.QOLBtn').forEach(btn => {
    const section = btn.closest('section');
    if (!section) return;

    const sectionId = section.dataset.sectionId || section.id;
    const target = section.querySelector('.quick-order-list');
    if (!target) return;

    // Apply inline styles for collapsed
    target.style.overflow = "hidden";
    target.style.transition = "max-height 0.4s ease";

    // Sync JS state or set default
    if (!quickOrderState.has(sectionId)) {
      quickOrderState.set(sectionId, "collapsed");
    }

    const state = quickOrderState.get(sectionId);
    target.style.maxHeight = state === "collapsed" ? "0px" : target.scrollHeight + "px";

    // Arrow icon
    const arrow = btn.querySelector('.QOL_Arrow');
    if (arrow) {
      arrow.classList.toggle('fa-chevron-up', state === "expanded");
      arrow.classList.toggle('fa-chevron-down', state === "collapsed");
    }
  });
}

// -------

// Move Varient Picker to top on Mobile devices

function moveVariantPicker() {
  const variantPicker = document.querySelector('[data-block-id="variant_picker"]');
  const vendor = document.querySelector('[data-block-id="vendor"]');

  if (window.innerWidth <= 768) { // mobile breakpoint
    if (variantPicker && vendor && variantPicker.nextSibling !== vendor) {
      vendor.parentNode.insertBefore(variantPicker, vendor);
    }
  } else {
    // Optional: restore original order on desktop
    const blockList = document.querySelector('.product-info__block-list');
    const buyButtons = document.querySelector('[data-block-id="buy_buttons"]');
    if (variantPicker && blockList && buyButtons) {
      blockList.insertBefore(variantPicker, buyButtons);
    }
  }
}



// ----------------------------------------------------------------------------

// Run on page load
moveVariantPicker();


// Run on page load
document.addEventListener('DOMContentLoaded', initQuickOrderSections);

// Optional: run after Shopify UI updates (MutationObserver)
const observer = new MutationObserver(() => {
  initQuickOrderSections();
});
observer.observe(document.body, { childList: true, subtree: true });
